export default {
    setSelectedPreOrder(state, preOrder) {
        state.selectedPreOrder = preOrder;
    },
    updatePreOrderUnitOrder(state, preOrders) {
        state.selectedPreOrder.units.forEach((unit) => {
            const match = preOrders.find((p) => p.id === unit.id);
            unit.unitId = match.unitId;
        });
    },
};
